import axios from 'axios';

const API_URL = 'https://expensetracker-yj7e.onrender.com/expenses';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};

const ExpenseService = {
  getExpenses: async () => {
    try {
      const response = await axios.get(API_URL, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error fetching expenses:', error);
      throw error;
    }
  },

  addExpense: async (expense) => {
    try {
      const response = await axios.post(API_URL, expense, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error adding expense:', error);
      throw error;
    }
  },

  updateExpense: async (id, updatedExpense) => {
    try {
      const response = await axios.put(`${API_URL}/${id}`, updatedExpense, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error updating expense:', error);
      throw error;
    }
  },

  deleteExpense: async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`, getAuthHeaders());
    } catch (error) {
      console.error('Error deleting expense:', error);
      throw error;
    }
  },

  clearAllExpenses: async () => {
    try {
      await axios.delete(API_URL, getAuthHeaders());
    } catch (error) {
      console.error('Error clearing all expenses:', error);
      throw error;
    }
  },
};

export default ExpenseService;
